import Cookies from 'js-cookie';
import qs from 'qs';
import apiPath from '@/lib/apiPath';
import request from '@/lib/request';
import { getQueryFromUrl, isProd, validatePageParams, isWechatBrowser } from '@/lib/utils';
import { rootStore } from '@/store/rootStore';
import { ElMessage } from 'element-plus';
import { isSingapore } from '../const';
export function login() {
  let token = getQueryFromUrl('access_token');
  const imToken = Cookies.get('IM-Token');
  return new Promise<void | boolean>((resolve, reject) => {
    let whiteList = ['/payment', '/mBindAccount', '/bindAccount', '/webview', '/officialToMini'];
    if (!whiteList.includes(location.pathname)) {
      if (token) {
        // 灵盾登录
        reLogin();
      } else if (validatePageParams('wechat_login') || validatePageParams('gzh')) {
        // 微信登录
        wxLogin();
      } else if (imToken) {
        resolve(true);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

export async function wxLogin() {
  try {
    const res = await request.get(apiPath.authorize.parseAuthorize.replace(':code', getQueryFromUrl('code')), {
      mark: 'service-center',
    });
    setWXLoginInfo(res);
    const imToken = Cookies.get('IM-Token');
    // 是否微信绑定账号
    let is_bind = await checkWechatBind();
    // 已绑定且无imToken，拿open_id换取
    if (!imToken && is_bind) {
      let token = await getTokenByOpenId();
      setCookie({
        'IM-Token': token,
      });
    }
    if (is_bind) {
      redirect();
    } else {
      location.href = `${location.origin}/mBindAccount`;
    }
  } catch (e) {
    loginError();
  }
}

async function getTokenByOpenId() {
  try {
    const res = await request.post(apiPath.wx.getTokenByOpenId, {
      open_id: getWXLoginInfo()?.openid,
    });
    return res;
  } catch (e) {
    loginError();
  }
}

export async function checkWechatBind() {
  // 非微信登录
  if (!getWXLoginInfo()?.openid) {
    return true;
  }
  const res = await request.post(apiPath.wx.checkWechatBind, {
    open_id: getWXLoginInfo()?.openid,
  });
  setWXBindAccountInfo(res);
  return res.is_bind;
}

let initQAInstanceFlag = false;
export async function getUserInfo() {
  const store = rootStore();
  const res = await request.get(apiPath.user.getUserInfo);
  const platform_id = isProd ? '165871928000000050' : '165485772400000050';
  if (isProd) {
    window.platformData &&
      window.platformData.init({
        platform_user_id: res.unify_id && res.unify_id !== '0' ? res.unify_id : res.dingding_unionid,
        platform_id,
      });
    res.unify_id &&
      window.LINGHIT_APM_SDK &&
      window.LINGHIT_APM_SDK.init({
        centerUserId: res.unify_id,
        appId: 'M69',
      });
  }
  if (!initQAInstanceFlag && !isWechatBrowser && res.unify_id && !isSingapore) {
    const qaUrl = isProd
      ? '//ai-resource-admin.linghit.cn/api/pub/getQaUrl'
      : '//sandbox-ai-resource-admin.linghit.cn/api/pub/getQaUrl';
    window.qaSDKInstance &&
      window.qaSDKInstance.init(`${qaUrl}?platform_id=${platform_id}&unify_user_id=${res.unify_id}`, {
        ballPosition: {
          bottom: 80,
          position: 'left',
        },
        welPopupDelayTime: 1000,
      });
    initQAInstanceFlag = true;
  }
  store.setUserInfo({
    name: res.name,
    avatar: res.avatar,
    avatar_color: res.customer_service?.avatar_color,
    teamRole: res.team.member_type,
    teamName: res.team.name,
    teamId: res.team.id,
    isSuper: res.is_super,
    id: res.id,
    enable_gzh: res.team.enable_gzh,
    enable_h5: res.team.enable_h5,
    enable_qywx: res.team.enable_qywx,
    enable_virtual_robot: res.team.enable_virtual_robot,
    dingding_unionid: res.dingding_unionid,
    unify_id: res.unify_id,
  });
  return res.name;
}

export async function getUserMenu() {
  let res = [];
  const store = rootStore();
  try {
    res = await request.get(apiPath.user.getUserMenu, {});
  } catch (e) {
    loginError();
  }
  store.setUserMenu(res);
  return getMenuMap(res);
}

async function reLogin() {
  try {
    const res = await request.get(apiPath.user.getToken, {
      access_token: getQueryFromUrl('access_token'),
    });
    setCookie(res);
    setLoginFromType('unify_login');
    setLoginInit('unify_login');
    redirect();
  } catch (e) {
    loginError();
  }
}
export function loginError() {
  ElMessage.error({
    message: '身份验证失敗，請重新登錄',
    duration: 2000,
    onClose: () => {
      Cookies.remove('IM-Token');
      Cookies.remove('WXLoginInfo');
      Cookies.remove('WXBindAccountInfo');
      location.href = window.location.origin + isWechatBrowser ? '/mLogin' : '/login';
    },
  });
}
export function redirect() {
  location.href = location.origin;
}

export function wechatLogin(url = window.location.origin) {
  let params = {
    platform: 'wechat',
    mark: 'service-center',
    url: window.location.origin + '?from=wechat_login',
    scope: 'snsapi_userinfo',
  };
  window.location.href = `${apiPath.authorize.applyAuthorize}?${qs.stringify(params)}`;
}

export function redirectExternalLogin() {
  if (isWechatBrowser && location.href != location.origin + '/mLogin') {
    location.href = location.origin + '/mLogin';
  }
  if (!isWechatBrowser && location.href != location.origin + '/login') {
    location.href = location.origin + '/login';
  }
}

export function setCookie(res: any) {
  Cookies.set('IM-Token', res['IM-Token'], { expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000) });
  // 灵盾返回字段，放在请求头
  const fields = ['X-LingDun-UserID', 'X-LingDun-RealName', 'X-LingDun-BackendToken'];
  const obj: any = {};
  fields.forEach((key) => {
    obj[key] = res[key];
  });
  Cookies.set('LINGDUN-HEADER-PARAMS', JSON.stringify(obj), {
    expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
  });
}

export function getLoginFromType() {
  return Cookies.get('LoginFromType');
}

// 登录方式标识
export function setLoginFromType(type: string) {
  Cookies.set('LoginFromType', type);
}
// 登录标识，区分登录后处理时机
export function setLoginInit(type: string) {
  Cookies.set('LoginInit', type);
}
export function getLoginInit() {
  return Cookies.get('LoginInit');
}

// 微信信息
export function setWXLoginInfo(res: any) {
  Cookies.set('WXLoginInfo', JSON.stringify(res));
}

export function getWXLoginInfo() {
  return JSON.parse(Cookies.get('WXLoginInfo') || '{}');
}

// 微信绑定账户信息，用于区分是否绑定
export function setWXBindAccountInfo(res: any) {
  Cookies.set('WXBindAccountInfo', JSON.stringify(res));
}

export function getWXBindAccountInfo() {
  return JSON.parse(Cookies.get('WXBindAccountInfo') || '{}');
}
function getMenuMap(list: Array<any>) {
  let map: Array<string> = [];
  list.forEach((i: any) => {
    map.push(i.uri);
    if (i.child) {
      map = map.concat(i.child.map((j: any) => j.uri));
    }
  });
  return map;
}
